//item__quantity//
var quantityInput = document.querySelectorAll('input.quantity__input');
quantityInput.forEach(function (quantity) {
    quantity.addEventListener('change', function () {
        let variantId = quantity.getAttribute('data-quantity-variant-id');
      console.log("variantId", variantId)
        let desiredQuantity = quantity.value;
        let finalMatchedItemKey = null;
        $.getJSON('/cart.js')
            .done(function(cart) {
                let items = cart.items;
                let MainItems = items.filter(function(item) {
                    return item.properties.cover_for == variantId && item.id == 48080934371668;
                });
                console.log('desiredQuantity:', desiredQuantity);
                console.log("MainItems:", MainItems);
            if (MainItems.length > 0) {
                finalMatchedItemKey = MainItems[0].key;
                console.log('finalMatchedItemKey:', finalMatchedItemKey);
                let updates = {};
                updates[finalMatchedItemKey] = desiredQuantity;
                console.log('updates:', updates);
                setTimeout(function(){
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('Cart updated successfully:', data);
                    var count = data.item_count;
                    $('.cart-count-bubble > span').text(count);
                    $.get('/cart', function(cart, textStatus) {
                    var html = $(cart).find('cart-items').html();
                    $('cart-items').html(html);
                    var footer = $(cart).find('.cart__footer').html();
                    $('.cart__footer').html(footer); 
                    });
                    // $(quantity).val(desiredQuantity)
                    quantity.value = desiredQuantity;
                    location.reload();
                })
                .catch(error => {
                    console.error('Error updating cart:', error);
                });
            }, 400)
            } else {
                console.log("MainItems is empty.");
                              setTimeout(function(){  
              location.reload();
            }, 400)
              
            }
        });
      
    });
});
//coverProduct__Added//
var coverCheckbox = document.querySelectorAll('.cart-item .product-wrapping-inner input.cover-boxxx');
coverCheckbox.forEach(function (coverProductCheckBox) {
    coverProductCheckBox.addEventListener('change', function () {
        var variant_id = this.value;
        var coverId = this.getAttribute('data-idCover');
        console.log(this.value, 'checked');
        let productCount = $(this).attr('data-cart-quantity')
        let checkboxColumn = $(this).parents('.product-wrapping.detail-single-col');
        let parentElement = this.parentElement;
        let cartItemElement = parentElement.closest('.cart-item');
        let quantityInput = cartItemElement.querySelector('quantity-input.quantity.cart-quantity input.quantity__input');
        let finalQuantity = quantityInput.value;
        console.log(checkboxColumn, 'checkboxColumnnnnnnnnmmmmmm')

        if($(coverProductCheckBox).prop('checked') == true || checked_val == true){
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    quantity: finalQuantity,
                    id: coverId,
                    'properties[Product Cover]': 'Added',
                    'properties[cover_for]': variant_id
                },
                dataType: 'json',
                success: function(data) {
                    console.log('Product added to cart:', data);
                    var count = data.item_count;
                    $('.cart-count-bubble > span').text(count);
                    $.get('/cart', function(cart, textStatus) {
                    var html = $(cart).find('cart-items').html();
                    $('cart-items').html(html);
                    var footer = $(cart).find('.cart__footer').html();
                    $('.cart__footer').html(footer); 
                    });
                    // $(quantity).val(desiredQuantity)
                    location.reload();
                    checkboxColumn.style.display = 'none';
                },
                error: function(xhr, status, error) {
                    console.error('Error adding product to cart:', error);
                }
            });
            
        } else {
            console.log(this.value, 'not checked')
        }
    });
});
//coverProduct__Remove//
var deleteBtn = document.querySelectorAll('cart-remove-button.baseProduct');
deleteBtn.forEach(function (delBtn) {
    delBtn.addEventListener('click', function () {
        let itemId = this.getAttribute('data-id');
        let finalMatchedItemKey = null;
        $.getJSON('/cart.js')
        .done(function(cart) {
            let items = cart.items;
            let MainItems = items.filter(function(item) {
                return item.properties.cover_for == itemId && item.id == 48080934371668;
            });
            if (MainItems.length > 0) {
                finalMatchedItemKey = MainItems[0].key;
                console.log('finalMatchedItemKey:', finalMatchedItemKey);
                let updates = {};
                updates[finalMatchedItemKey] = 0;
                console.log('updates:', updates);
                // debugger;
                setTimeout(function(){
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log('Cart updated successfully:', data);
                    var count = data.item_count;
                    $('.cart-count-bubble > span').text(count);
                    $.get('/cart', function(cart, textStatus) {
                    var html = $(cart).find('cart-items').html();
                    $('cart-items').html(html);
                    var footer = $(cart).find('.cart__footer').html();
                    $('.cart__footer').html(footer); 
                    });
                    // $(quantity).val(desiredQuantity)
                    
                    location.reload();
                })
                .catch(error => {
                    console.error('Error updating cart:', error);
                });
            }, 200)
            } else {
                console.log("MainItems is empty.");
                               setTimeout(function(){  
              location.reload();
            }, 400)
            }
        });
    });
});